import SEO from "../../components/SEO";
import { Link } from "react-router-dom";

export default function TermsPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "利用規約 - dot Blue",
    "description": "dot Blue株式会社の利用規約です。",
    "url": `${siteUrl}/terms`,
    "publisher": {
      "@type": "Organization",
      "name": "dot Blue",
      "url": siteUrl
    }
  };

  return (
    <>
      <SEO
        title="利用規約 - dot Blue"
        description="dot Blue株式会社の利用規約です。サービス利用に関する規約を説明しています。"
        keywords="利用規約, サービス規約, dot Blue"
        ogImage={`${siteUrl}/og-image-terms.jpg`}
        schema={webPageSchema}
      />

      <div className="min-h-screen bg-white">
        {/* Header */}
        <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100">
          <div className="max-w-7xl mx-auto px-6 py-4">
            <div className="flex items-center justify-between">
              <Link to="/" className="flex items-center gap-3">
                <span className="text-xl font-bold text-gray-900">dot Blue</span>
              </Link>
              <Link
                to="/"
                className="px-6 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                ホームに戻る
              </Link>
            </div>
          </div>
        </header>

        {/* Main Content */}
        <main className="pt-24 pb-20">
          <div className="max-w-4xl mx-auto px-6">
            <h1 className="text-4xl font-bold text-gray-900 mb-8">サービス利用規約（法人向け）</h1>

            <div className="prose prose-lg max-w-none">
              <p className="text-gray-700 leading-relaxed mb-8">
                本規約は、株式会社dot Blue（以下「当社」）が提供する法人向けサービス（AI導入支援、AIチャット/エージェントの企画・開発・運用支援、AI Insider 等。以下「本サービス」）の利用条件を定めるものです。お客様（法人または個人事業主。以下「利用者」）は、本規約に同意の上、本サービスを利用するものとします。
              </p>

              <section className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-blue-600 pb-2">第1条（適用）</h2>
                <ol className="list-decimal pl-6 space-y-3 text-gray-700">
                  <li>本規約は、当社と利用者との間の本サービスの利用に関する一切の関係に適用されます。</li>
                  <li>個別案件について当社と利用者が別途締結する契約書、発注書、見積書、SOW（作業範囲合意書）等（以下総称して「個別契約」）が本規約と矛盾する場合、個別契約が優先します。</li>
                </ol>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-blue-600 pb-2">第2条（契約の成立）</h2>
                <p className="text-gray-700 leading-relaxed">
                  本サービスの利用契約は、利用者からの申込みに対し当社が承諾し、個別契約の締結または発注の確定等により成立します。
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-blue-600 pb-2">第3条（本サービスの内容）</h2>
                <ol className="list-decimal pl-6 space-y-3 text-gray-700">
                  <li>当社は、利用者の課題に応じて、AI活用に関する設計・実装・運用改善等の支援を行います。</li>
                  <li>当社は、本サービスの提供にあたり、外部サービス（クラウド/解析ツール/LLM API 等）を利用する場合があります。</li>
                </ol>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-blue-600 pb-2">第4条（料金および支払）</h2>
                <ol className="list-decimal pl-6 space-y-3 text-gray-700">
                  <li>本サービスの料金、支払条件は、個別契約で定めます。</li>
                  <li>利用者は、当社が定める支払期限までに、個別契約に基づき料金を支払うものとします。</li>
                </ol>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-blue-600 pb-2">第5条（利用者の協力事項）</h2>
                <p className="text-gray-700 leading-relaxed mb-3">
                  利用者は、本サービスの円滑な提供のため、以下に協力するものとします。
                </p>
                <ol className="list-decimal pl-6 space-y-2 text-gray-700">
                  <li>必要な情報・資料・権限等の提供</li>
                  <li>重要事項の確認および意思決定の適時実施</li>
                  <li>利用者側の関係者（法務/広報/人事/CS 等）との調整</li>
                </ol>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-blue-600 pb-2">第6条（AIの利用に関する留意事項）</h2>
                <ol className="list-decimal pl-6 space-y-3 text-gray-700">
                  <li>当社は、本サービスの一部でAI（生成AIを含む）を利用する場合があります。AIの出力は統計的推定に基づくものであり、誤りや不正確な内容を含む可能性があります。</li>
                  <li>利用者は、AIの出力を参考情報として取り扱い、採用、法務、医療、金融等の重要判断については、必要に応じて専門家確認を行うものとします。</li>
                  <li>当社は、AIの出力結果またはAIの利用により得られる成果について、特定の効果（ROI、CV等）を保証しません。</li>
                </ol>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-blue-600 pb-2">第7条（禁止事項）</h2>
                <p className="text-gray-700 leading-relaxed mb-3">
                  利用者は、本サービスの利用にあたり、以下の行為を行ってはなりません。
                </p>
                <ol className="list-decimal pl-6 space-y-2 text-gray-700">
                  <li>虚偽の情報提供</li>
                  <li>当社または第三者の権利（著作権、商標権、プライバシー等）を侵害する行為</li>
                  <li>不正アクセス、脆弱性探索、リバースエンジニアリング等の行為</li>
                  <li>法令または公序良俗に反する行為</li>
                  <li>当社または第三者に過度な負荷や障害を与える行為</li>
                  <li>その他当社が不適切と判断する行為</li>
                </ol>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-blue-600 pb-2">第8条（知的財産権）</h2>
                <ol className="list-decimal pl-6 space-y-3 text-gray-700">
                  <li>本サービスに関連して当社が提供する資料、成果物、設計、プロンプト、ノウハウ等の知的財産権は、個別契約で別段の定めがない限り、当社に帰属します。</li>
                  <li>当社は、利用者に対し、個別契約の範囲で本サービスの成果物等を利用するための非独占的な利用許諾を行います。</li>
                </ol>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-blue-600 pb-2">第9条（サービスの中断・停止）</h2>
                <p className="text-gray-700 leading-relaxed mb-3">
                  当社は、以下の場合、本サービスの全部または一部を中断または停止することがあります。
                </p>
                <ol className="list-decimal pl-6 space-y-2 text-gray-700 mb-4">
                  <li>保守・点検・更新等（メンテナンス）を行う場合</li>
                  <li>障害、災害、停電、通信回線障害等により提供が困難となった場合</li>
                  <li>その他当社が合理的に必要と判断した場合</li>
                </ol>
                <p className="text-gray-700 leading-relaxed">
                  当社は、可能な範囲で事前に通知するよう努めますが、緊急の場合は事後の通知となることがあります。
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-blue-600 pb-2">第10条（反社会的勢力の排除）</h2>
                <p className="text-gray-700 leading-relaxed">
                  利用者および当社は、反社会的勢力に該当しないこと、また将来にわたり該当しないことを表明し保証します。反社会的勢力に該当すると判明した場合、当社は何らの催告なく契約を解除できるものとします。
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-blue-600 pb-2">第11条（解除）</h2>
                <p className="text-gray-700 leading-relaxed">
                  当社は、利用者が本規約または個別契約に違反し、相当期間を定めて是正を求めても是正されない場合、契約を解除できるものとします。緊急性が高い場合は、この限りではありません。
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-blue-600 pb-2">第12条（損害賠償）</h2>
                <p className="text-gray-700 leading-relaxed">
                  当社の損害賠償責任の範囲・上限は、個別契約で定めます。個別契約に定めがない場合、当社の責任は、当社の故意または重過失がある場合を除き、直接かつ通常の損害に限られるものとします。
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-blue-600 pb-2">第13条（準拠法・合意管轄）</h2>
                <p className="text-gray-700 leading-relaxed">
                  本規約は日本法に準拠し、本サービスに関して紛争が生じた場合、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-blue-600 pb-2">第14条（規約の変更）</h2>
                <p className="text-gray-700 leading-relaxed">
                  当社は、必要に応じて本規約を変更することがあります。変更内容は当社ウェブサイト上に掲示し、掲示後に利用者が本サービスを利用した場合、変更に同意したものとみなします。
                </p>
              </section>

              <div className="border-t-2 border-gray-200 pt-6 mt-10">
                <p className="text-gray-700 font-semibold">制定日：2026年1月19日</p>
                <p className="text-gray-700 font-semibold">株式会社dot Blue</p>
              </div>
            </div>
          </div>
        </main>

        {/* Footer */}
        <footer className="bg-gray-900 text-white py-8">
          <div className="max-w-7xl mx-auto px-6">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <div className="flex items-center gap-3">
                <span className="text-lg font-bold">dot Blue</span>
              </div>
              <div className="flex gap-6 text-sm">
                <Link to="/privacy-policy" className="hover:text-blue-400 transition-colors cursor-pointer">
                  プライバシーポリシー
                </Link>
                <Link to="/terms" className="hover:text-blue-400 transition-colors cursor-pointer">
                  利用規約
                </Link>
                <Link to="/security" className="hover:text-blue-400 transition-colors cursor-pointer">
                  セキュリティ
                </Link>
                <a href="mailto:contact@aidotblue.com" className="hover:text-blue-400 transition-colors cursor-pointer">
                  お問い合わせ
                </a>
              </div>
            </div>
            <div className="text-center text-sm text-gray-400 mt-6">
              Copyright © dot Blue Inc. All Rights Reserved.
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}
